import React from 'react';
import Drawer from '@mui/material/Drawer';
import { NotificationsAppBar } from './NotificationsAppBar';
import { Alert } from '@mui/material';
import { justCentered } from '../../../helpers/utils';
import { NotificationCard } from './NotificationCard';

export const NotificationsBar = ({
	open = false,
	handleClose = null,
	notifications = [],
	pendingNotifications = 0,
}) => {
	return (
		<Drawer anchor='right' open={open} onClose={handleClose}>
			<div style={{ width: '400px', height: '100%' }}>
				<NotificationsAppBar
					handleClose={handleClose}
					pendingNotifications={pendingNotifications}
				/>

				<div
					style={{ margin: '15px', height: '90%', maxHeight: '90%' }}
				>
					{notifications.length > 0 ? (
						<div>
							{notifications.map((item) => (
								<NotificationCard
									key={item.id}
									data={item}
									handleClose={handleClose}
								/>
							))}
						</div>
					) : (
						<div
							style={{
								margin: '20px',
								height: '100%',
								...justCentered,
							}}
						>
							<Alert severity='success'>
								No hay nuevas notificaciones
							</Alert>
						</div>
					)}
				</div>
			</div>
		</Drawer>
	);
};
